import * as React from 'react';
import { Link } from 'react-router-dom';
const Introduction = () => (
	<p>
		This page showcases a synthesizer trained on less than 13 minutes of non-annotated audio. The system consists of
		three parts:
		<ul>
			<li>
				A <b>midi transcriber</b> which takes an audio clip and creates a midi annotation used for training.
			</li>
			<li>
				A <b>control model</b> which estimates intermediate features (loudness and pitch in these examples) from
				midi.
			</li>
			<li>
				A <b>synthesis model</b> which transforms the intermediate features into audio. The synthesis model used
				in these examples comes from <a href="https://magenta.tensorflow.org/ddsp">DDSP</a> by Magenta.
			</li>
		</ul>
		The two model structure enables some <Link to="/controlflexibility">fun control flexibility</Link>.<br></br>
		<br></br>
		The violin model was trained in these examples was trained on{' '}
		<a href="https://musopen.org/music/13574-violin-partita-no-1-bwv-1002">
			Five pieces by John Garner (II. Double, III. Corrente, IV. Double Presto, VI. Double, VIII. Double){' '}
		</a>
		(reference via ddsp). The flute model was trained on{' '}
		<a href="https://musopen.org/music/24732-3-fantaisies-for-solo-flute-op-38/">
			3 Fantaisies for Solo Flute, Op. 38 - Fantaisie no. 1 performed by Paolo Dalmoro{' '}
		</a>
		<br></br>
		<br></br>
		{/* This project was the result of a master thesis conducted at KTH Royal Instute of Technology with support from
		Epidemic Sound. The project was mentored by Carl Thomé and Daniel Klevebring at Epidemic sound and Bob Sturm at
		KTH Royal Instute of Technology. */}
		<br></br>
		<br></br>
		<img style={{ height: 45, width: 'auto' }} src={process.env.PUBLIC_URL + '/m.png'}></img>
	</p>
);

export default Introduction;
